import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, compose, applyMiddleware} from 'redux';
import {createEpicMiddleware} from 'redux-observable';
import rootEpic from './wizard/epics/rootEpic';
import rootReducer from './wizard/reducers/rootReducer';
import {ConnectedRouter, routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import RoutesView from './wizard/components/views/RoutesView';
import * as UIActions from './wizard/actions/UIActions';
import {COUNTRIES} from './wizard/constants/AppConstants';
import {defaultState} from './wizard/reducers/state';
import {persistStore, persistReducer} from 'redux-persist';
import session from 'redux-persist/lib/storage/session';
import {PersistGate} from 'redux-persist/integration/react';
import '../stylesheets/wizard.scss';
import * as Environment from './admin/constants/EnvironmentConstants';
import { SSOMiddleware } from './wizard/middlewares/SSOMiddleware';
import RoutesContainer from './wizard/containers/mx/RoutesContainer';
import {createRoot} from 'react-dom/client';

const persistConfig = {
    key: 'motorfy',
    storage: session
};

const epicMiddleware = createEpicMiddleware({
    dependencies: {country: COUNTRIES.MX.id}
});

const history = createBrowserHistory();
const middleware = routerMiddleware(history);
const persistedReducer = persistReducer(persistConfig, rootReducer(history));
const composeEnhancers = Environment.ENVIRONMENT !== Environment.PRODUCTION_ENV &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
    applyMiddleware(...[epicMiddleware, middleware, SSOMiddleware]),
);

const store = createStore(
    persistedReducer,
    // @ts-ignore
    defaultState,
    enhancer
);

epicMiddleware.run(rootEpic);

const persistor = persistStore(store);
window.onpopstate = function (event) {
    history.go(1);
};

const runInitialAppStartActions = () => {
    const isLoaded = store.getState().catalogs.catalogIsLoaded;
    store.dispatch(UIActions.INIT_APP_ACTION.action(COUNTRIES.MX.id));
};

const container = document.getElementById('wizard');
const root = createRoot(container); // createRoot(container!) si usas TypeScript
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor} onBeforeLift={runInitialAppStartActions}>
            <ConnectedRouter history={history}>
                <RoutesContainer />
            </ConnectedRouter>
        </PersistGate>
    </Provider>);
